export default "__VITE_PUBLIC_ASSET__76286647__"